import _ from 'lodash'
import type {ReactElement} from 'react'
// Components
import QuestionList from '../question-list'
// Types
import type {BallotPageBlock, ParentCategory} from '../../types/ballot'

interface QuestionListBlockProps {
  block: BallotPageBlock
}

const getGroup = (block: BallotPageBlock): ParentCategory | null => {
  return _.first(block.formValuesObject.blockSelectedGroup) || null
}

const QuestionListBlock = ({block}: QuestionListBlockProps): ReactElement | null => {
  const group = getGroup(block)

  if (!group) return null

  return <QuestionList group={group} />
}

export default QuestionListBlock
